var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#24FF00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3369 4.34091C13.5235 4.51095 13.537 4.80008 13.3669 4.98671L7.83547 11.0578L4.24606 7.41054C4.06897 7.23059 4.07129 6.94115 4.25124 6.76406C4.43118 6.58697 4.72062 6.58928 4.89771 6.76923L7.80989 9.72838L12.6911 4.37094C12.8611 4.18432 13.1503 4.17087 13.3369 4.34091Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 0.914286C4.08666 0.914286 0.914285 4.08667 0.914285 8C0.914285 11.9133 4.08666 15.0857 7.99999 15.0857C11.9133 15.0857 15.0857 11.9133 15.0857 8C15.0857 7.74753 15.2904 7.54286 15.5428 7.54286C15.7953 7.54286 16 7.74753 16 8C16 12.4183 12.4183 16 7.99999 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 7.99999 0C8.25247 0 8.45714 0.20467 8.45714 0.457143C8.45714 0.709616 8.25247 0.914286 7.99999 0.914286Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_circle.807187a1.svg";
export { ForwardRef as ReactComponent };